/*
 * View for Tenants
 */

define([
  "marionette",
  "modules/accountAdmin/tenantAdmin/template/tenantAdminTemplate.html",
], function (Marionette, TenantAdminTemplate) {
  var TenantAdminView = {};

  TenantAdminView.tenantAdminLayout = Marionette.Layout.extend({
    template: TenantAdminTemplate,
    regions: {
      list: "#tenantList",
    },
    triggers: {
      "click #addTenant": "add:tenant",
    },
  });

  return TenantAdminView;
});
